const autoNgTemplateLoaderTemplate1 = require('./secret.html');

angular.module('portainer.kubernetes').component('kubernetesSecretView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesSecretController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
